import { Component, OnInit,ElementRef, ViewChild  } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { HistoryProductService } from "./history-product.service";
import { lang_notificaciones } from 'app/idiomas/i18n/notificaciones/notificaciones.lang';
import {TranslateService} from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
  {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
];

@Component({
  selector: 'app-history-product',
  templateUrl: './history-product.component.html',
  styleUrls: ['./history-product.component.scss'],
  animations : fuseAnimations
})

export class HistoryProductComponent implements OnInit {
  displayedColumns: string[] = ['user', 'fechaProducto', 'tipoProducto', 'adminUser','accion'];
  // dataSource: any;
  notificacionesGenerales:any[]=[];
  infoHistorialOriginal:any[]=[];
  infoHistorial:any[]=[];
  moment = require('moment');
  userData:any;
  // busqueda:any;
  // form= document.getElementById("busquedaForm");
  cargando=true;
  filtroAbierto=false;
  fechaBuscar="";
  idiomaActual:string;
  conDatos=false;
  constructor(
    private history: HistoryProductService,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
    if(localStorage.getItem('userBypass')){
      this.userData=JSON.parse(localStorage.getItem('userBypass'));

    }

    lang_notificaciones.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.getNotificacionesEmpresaId();
    // this.funcion();
  }



  getNotificacionesEmpresaId(){
  this.notificacionesGenerales=[];
    this.history.getNotificacionesEmpresaID(localStorage.getItem('companyID')).subscribe((respuesta:any) => {
      console.log('respuesta',respuesta);

      respuesta.historial.forEach(tipProduct => {
            tipProduct.historial.forEach(historialProduc => {
            historialProduc.productoId=tipProduct.productoId;
            historialProduc.tipoProducto=tipProduct.tipoProducto;
            historialProduc.fechaProducto=tipProduct.fechaProducto;
            historialProduc.mostrar=false;

            this.notificacionesGenerales.push(historialProduc);
          });
      });
console.log('notificacionesGenerales',this.notificacionesGenerales);

// this.dataSource=this.notificacionesGenerales;

this.infoHistorialProductos(this.notificacionesGenerales);
    });
  }

  infoHistorialProductos(notificacionesGenerales){
    console.log("Entro este visne del 3");

    let fechaActual:number;
    let fechaPulse:any[]=[];
    let pulseV3:any[]=[];
    notificacionesGenerales.sort( (a,b) => {
      if(b.createdAt > a.createdAt){
        return 1;
      } else{
        return -1;
      }
    });



    notificacionesGenerales.forEach((element,i) => {
      // console.log("entro producto pulsechek 3.0");
      if(fechaActual){
        // console.log('entro fechaActual true ');

        if(this.moment(element.createdAt).format('MM/DD/YYYY') == fechaActual){
          fechaPulse.push(element);
        }
        else {
          this.infoHistorial.push({fecha: fechaActual, datos: fechaPulse });
          fechaPulse=[];
          fechaActual=this.moment(element.createdAt).format('MM/DD/YYYY');
          fechaPulse.push(element);
        }
      }
      else{
        // console.log('entro fechaActual true ');
        fechaActual=this.moment(element.createdAt).format('MM/DD/YYYY');
        fechaPulse.push(element);

      }

      // console.log(fechaPulse);
      if(notificacionesGenerales.length ==(i+1)){
        console.log('si entro jdsfsdasmdka');
        this.infoHistorial.push({fecha: this.moment(element.createdAt).format('MM/DD/YYYY'), datos: fechaPulse });
    }
    });
    this.cargando=false;
    console.log(this.infoHistorial);
    this.infoHistorialOriginal= JSON.parse(JSON.stringify(this.infoHistorial));
    if(this.infoHistorial.length>0) {
      this.conDatos=true;
    }

  }

//  buscar(id){
// let busqueda= (document.getElementById(id)).value;
//    this.infoHistorial= this.infoHistorial.filter(persona=>{
// return persona.fecha.toLowerCase().indexOf(busqueda)>-1;
//    })
//  }
//
// funcion(){
//   this.busqueda= new Busqueda();
//   this.form.addEventListener('submit',() =>{
//     this.busqueda.buscar('valor');
//   });
//
// }



mostrarTr(index1,index2){
  console.log('index1',index1);
  console.log('index2',index2);
  if (this.infoHistorial[index1].datos[index2].mostrar==false) {
    this.infoHistorial[index1].datos[index2].mostrar=true;
  }else{
    this.infoHistorial[index1].datos[index2].mostrar=false;
  }
  //
  // document.getElementById('infoExtra1').style.display = "";
  // document.getElementById('infoExtra2').style.display = "";
  // document.getElementById('infoExtra3').style.display = "";
  // document.getElementById('infoExtra4').style.display = "";
  // document.getElementById('infoExtra5').style.display = "";
}


filtrarInformacion(){
  if (this.fechaBuscar!='') {
    this.resetInformacion();
    console.log("fechaBuscar",this.fechaBuscar);
    let fecha= this.moment(this.fechaBuscar).format('MM/DD/YYYY');
    console.log('fecha construida',fecha);
    let encontrado:any[]=[];
    this.infoHistorial.forEach(fechas => {
      if (fechas.fecha==fecha) {
        encontrado.push(fechas)
      }
    });
    this.infoHistorial=encontrado;
    console.log('infoHistorial despues de filtrar',this.infoHistorial);
    if (this.infoHistorial.length>0) {
      this.conDatos=true;
    }else{
      this.conDatos=false;
    }

  }else{
    alert("Selecciona una fecha");
  }
}

resetInformacion(){
  this.infoHistorial=JSON.parse(JSON.stringify(this.infoHistorialOriginal));
  this.conDatos=true;
}

}
